/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiVendorActivityLogGet } from '../fn/vendor-activity-log/api-vendor-activity-log-get';
import { ApiVendorActivityLogGet$Params } from '../fn/vendor-activity-log/api-vendor-activity-log-get';
import { RfqVendorActivityLog } from '../models/rfq-vendor-activity-log';

@Injectable({ providedIn: 'root' })
export class VendorActivityLogService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiVendorActivityLogGet()` */
  static readonly ApiVendorActivityLogGetPath = '/api/vendor/activityLog';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiVendorActivityLogGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVendorActivityLogGet$Response(params?: ApiVendorActivityLogGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<RfqVendorActivityLog>>> {
    return apiVendorActivityLogGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiVendorActivityLogGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiVendorActivityLogGet(params?: ApiVendorActivityLogGet$Params, context?: HttpContext): Observable<Array<RfqVendorActivityLog>> {
    return this.apiVendorActivityLogGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<RfqVendorActivityLog>>): Array<RfqVendorActivityLog> => r.body)
    );
  }

}
